import { useEffect, useState } from 'react';
import { firestore, doc, onSnapshot, setDoc } from '../lib/firebase';

const CONFIG_DOC_PATH = ['config', 'games'] as const;

interface AppConfig {
  disabledGames: Set<string>;
  loading: boolean;
}

let cache: { disabled: Record<string, boolean> } = { disabled: {} };

export function useAppConfig(): AppConfig {
  const [disabled, setDisabled] = useState<Record<string, boolean>>(cache.disabled);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const ref = doc(firestore, CONFIG_DOC_PATH[0], CONFIG_DOC_PATH[1]);
    const unsub = onSnapshot(
      ref,
      (snap) => {
        const data = snap.data();
        const next = (data?.disabled as Record<string, boolean>) ?? {};
        cache = { disabled: next };
        setDisabled(next);
        setLoading(false);
      },
      () => setLoading(false),
    );
    return unsub;
  }, []);

  const disabledGames = new Set(
    Object.entries(disabled)
      .filter(([, v]) => v === true)
      .map(([k]) => k),
  );
  return { disabledGames, loading };
}

export async function setGameDisabled(gameId: string, isDisabled: boolean): Promise<void> {
  const ref = doc(firestore, CONFIG_DOC_PATH[0], CONFIG_DOC_PATH[1]);
  const next = { ...cache.disabled, [gameId]: isDisabled };
  if (!isDisabled) delete next[gameId];
  cache = { disabled: next };
  await setDoc(ref, { disabled: next }, { merge: true });
}
